import { UploadedFileType } from "../models/forms/uploadFileType";
import { UtilityDate } from "./dateUtils";

const isUploadedFileTypeArray = (data: any): data is UploadedFileType[] => {
  return (
    Array.isArray(data) &&
    data.length > 0 &&
    typeof data[0] === "object" &&
    "blobFile" in data[0]
  );
};

export const generateMultipartFormData = <T>(formData: T): FormData => {
  const multipartFormData = new FormData();

  for (let _key in formData) {
    const key = _key as unknown as keyof T;
    const data = formData[key];
    if (!data) multipartFormData.append(String(key), "");
    else if (isUploadedFileTypeArray(data))
      data.map((file) => multipartFormData.append(String(key), file.blobFile));
    else if (data instanceof Date)
      multipartFormData.append(String(key), UtilityDate.ToIsoUtcDateTime(data));
    else if (
      Array.isArray(data) &&
      data.every((item) => typeof item === "string")
    )
      data.map((item) => multipartFormData.append(String(key), item));
    else multipartFormData.append(String(key), data as unknown as string);
  }

  return multipartFormData;
};

export function DoesObjectHasAnyInvalidValue(
  object:
    | {
        [key: string]: unknown;
      }
    | number
    | Date
    | string
    | Array<unknown>,
  ..._: unknown[]
): boolean {
  if (object === undefined || object === null) return true;
  return Array.isArray(object)
    ? false
    : typeof object === "number"
    ? false
    : object instanceof Date
    ? false
    : typeof object === "string"
    ? object === ""
    : Object.keys(object).some(DoesObjectHasAnyInvalidValue);
}
